import React, { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    DateInput,
    useNotify,
    useRedirect,
    SelectInput,
    FormDataConsumer,
    FileInput,
    FileField,
    ImageInput,
    ImageField,
    FormDataConsumerRenderParams,
    ReferenceInput, BooleanInput
} from 'react-admin';
import {
    Grid,
    Box,
    Stack
} from '@mui/material';
import { CmsEditor } from "../edit/components/Cms/CmsEditor";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const CustomerTutorialCreate: () => JSX.Element = (): JSX.Element => {

    const statuses: { id: string, name: string }[] = [
        { id: 'enabled', name: 'Enabled' },
        { id: 'disabled', name: 'Disabled' },
    ];

    const types: { id: string, name: string }[] = [
        { id: 'general', name: 'General' },
        { id: 'mini', name: 'Mini' },
    ];

    return (
        <Create redirect="edit">
            <SimpleForm>
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <TextInput name="name" source="name" validate={[required()]} fullWidth />
                        <SelectInput source="type" name="type" defaultValue="general" choices={ types } />
                        <SelectInput source="status" name="status" defaultValue="disabled" choices={ statuses } />
                        <TextInput name="shortDescription"
                                   source="shortDescription"
                                   helperText="255 max character count"
                                   fullWidth
                                   validate={[required()]}
                                   multiline
                                   format={ (value: string): string => value?.substring(0, 254) }
                                   rows={ 5 }
                        />
                        <FormDataConsumer<{ type: string }>>
                            { ( { formData, ...rest }: FormDataConsumerRenderParams ): JSX.Element => {
                                return (
                                    <ReferenceInput reference="nok_minis"
                                                    source="mini"
                                                    target="id">
                                        <SelectInput source="name"
                                                     label="Mini"
                                                     validate={ (formData.type === 'mini' ? [required()] : null) }
                                        />
                                    </ReferenceInput>
                                );
                            } }
                        </FormDataConsumer>
                        <BooleanInput source="showOnLandingTrident" />
                        <FileInput source="video" accept={{ 'video/*': [] }}>
                            <FileField source="src" title="title" />
                        </FileInput>
                        <FileInput source="captions"
                                   label="Captions"
                                   accept={{ 'text/vtt': ['.vtt'] }}
                                   helperText="WebVTT (.vtt) closed captions for the uploaded video. YouTube videos use the captions set on YouTube.">
                            <FileField source="src" title="title" />
                        </FileInput>
                        <TextInput name="videoDuration" source="videoDuration"
                                   helperText="Use HH:MM:SS format"
                                   fullWidth />
                        <ImageInput name="thumbnail"
                                    source="thumbnail"
                                    helperText="Required if a video has been set"
                                    label="Thumbnail"
                                    accept={{ 'image/*': ['.jpg', '.png', '.gif', '.jpeg'] }}>
                            <ImageField source="src" title="title" />
                        </ImageInput>
                    </Grid>
                    <Grid size={ 6 }>
                        <Stack spacing={ 2 } >
                            <Box sx={ { width: '100%', margin: '0 0 10px 0' } } >
                                <span>{ "Transcript or Text Tutorial" }</span>
                            </Box>
                            <CmsEditor formKey="transcript" />
                        </Stack>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}